import React, { useEffect, useState } from "react";
import { fetchHoldingAccount } from "../../helper/Api";
import moment from "moment";

const HoldingAccountBalanceOverlay = ({
  openOverlay,
  holdingAccountBalanceOverlays,
  fetchHoldingAccountBalance,
  fy_list,
}) => {
  const [holdingOverlayOpen, setHoldingOverlayOpen] = useState(true);
  const storedGlobalDateId = localStorage.getItem("globalDateId");
  const [holdingAccount, setHoldingAccount] = useState(null);

  const formatNumber = (number, style = "international") => {
    const formatted = parseFloat(number).toFixed(2);
    if (style === "indian") {
      return formatted.replace(/\B(?=(\d{3})(\d{2})*(?!\d))/g, ",");
    }
    return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const openHoldingOverlay = (value) => {
    setHoldingOverlayOpen(value);
    holdingAccountBalanceOverlays(value);
  };

  useEffect(() => {
    setHoldingOverlayOpen(openOverlay);
  }, [openOverlay]);

  const getHoldingAccount = async () => {
    const accountData = await fetchHoldingAccount();
    if (accountData?.data?.status) {
      const result = accountData.data.result;
      setHoldingAccount(result);
      fetchHoldingAccountBalance(result);
    }
  };

  useEffect(() => {
    getHoldingAccount();
  }, [storedGlobalDateId]);

  return (
    <div>
      <div
        className={`bank-balance-overlay ${holdingOverlayOpen ? "d-none" : null}`}
      />

      <div
        className={`bank-balance-overlay-flow overflow-x-hidden ${
          holdingOverlayOpen ? "left-100" : null
        }`}
      >
        <p className="bg-warning-100 position-relative text-white p-3 fw-600 fs-18px d-flex justify-content-between align-items-center position-sticky top-0">
          <div className="d-flex gap-1 align-items-center">
            <span>
              <i
                className="icon-close_circle_fill cursor-pointer text-white"
                onClick={() => openHoldingOverlay(true)}
              />
            </span>
            <span className="fw-500">Holding Account Balance FY</span>
            <select
              name="financial_year_id"
              className="bg-transparent border-0 text-white fw-500 fs-16px select"
              disabled
            >
              <option value="" className="text-black">
                select year
              </option>
              {fy_list?.map((fy) => (
                <option
                  value={storedGlobalDateId}
                  key={fy.id}
                  className="text-black"
                  selected={
                    String(fy.id) === storedGlobalDateId ||
                    (!storedGlobalDateId &&
                      fy.start_year === moment().format("YYYY"))
                  }
                >
                  {fy.year}
                </option>
              ))}
            </select>
          </div>
        </p>

        <div className="overflow-auto px-3 fs-14px m-0 h-100">
          {!holdingAccount ? (
            <div className="py-4 text-center text-black-50">
              No holding accounts found
            </div>
          ) : (
            <>
              <div className="row bg-prime-100 p-0 m-0 py-2 px-2">
                <div className="col-4 p-0 m-0 text-white fs-14px">Account</div>
                <div className="col-4 p-0 m-0 text-white fs-14px">Balance</div>
                <div className="col-4 p-0 m-0 text-white fs-14px">Interest</div>
              </div>

              <div className="row p-0 m-0 py-2 px-2 border-bottom">
                <div className="col-4 p-0 m-0 fs-14px">
                  <div>{holdingAccount?.account_name || "Holding Account"}</div>
                  <div className="fs-12px text-black-50">{holdingAccount?.account_no}</div>
                </div>
                <div className="col-4 p-0 m-0 fs-14px">
                  <div className="fw-600">
                    {formatNumber(holdingAccount?.account_balance, "indian")}
                  </div>
                  {holdingAccount?.balance_date && (
                    <div className="fs-12px fst-italic">
                      as on {holdingAccount.balance_date}
                    </div>
                  )}
                </div>
                <div className="col-4 p-0 m-0 fs-14px">
                  <div className="row">
                    {[1, 2, 3, 4].map((q) => (
                      <div className="col-6 m-0 p-0" key={q}>
                        Q{q}:{" "}
                        {holdingAccount?.quarterlyInterest?.find(
                          (item) => String(item?.quarter) === String(q)
                        )?.amount || "-"}
                      </div>
                    ))}
                  </div>
                  <div className="text-end text-success-100 fs-14px fw-500">
                    Total:{" "}
                    {holdingAccount?.quarterlyInterest?.reduce(
                      (sum, item) => sum + Number(item?.amount || 0),
                      0
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HoldingAccountBalanceOverlay;
